import PropTypes from 'prop-types';
import {dateTimeFormatUK} from '../../../utils/commonFunctions';

class LogBody {
  static email = ({to, sent, subject}) => (
    <div>
      <p>To: <b>{to}</b></p>
      <p>Subject: {subject}</p>
      <p>Sent: {dateTimeFormatUK(sent)}</p>
    </div>
  );

  static mobile = ({to, sent, message}) => (
    <div>
      <p>To: <b>{to}</b></p>
      <p>
        Message:{' '}
        <span style={{whiteSpace: 'pre-wrap'}}>
          {message}
        </span>
      </p>
      <p>Sent: {dateTimeFormatUK(sent)}</p>
    </div>
  );
}

LogBody.email.propTypes = {
  to: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  sent: PropTypes.string.isRequired,
};

LogBody.mobile.propTypes = {
  to: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  sent: PropTypes.string.isRequired,
};

export default LogBody;
